import script from "./Registration.vue?vue&type=script&setup=true&lang=ts"
export * from "./Registration.vue?vue&type=script&setup=true&lang=ts"

import "./Registration.vue?vue&type=style&index=0&id=35a09584&scoped=true&lang=css"
import "./Registration.vue?vue&type=style&index=1&id=35a09584&scoped=true&lang=css"
import "./Registration.vue?vue&type=style&index=2&id=35a09584&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a09584"]])

export default __exports__